import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef, useContext } from "react";
import { Table, Card, CardBody, Col, Container, Row, Modal, ModalHeader, ModalBody, Spinner, UncontrolledTooltip, Accordion, AccordionItem, Collapse } from "reactstrap";
import "moment-timezone";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone, forEach } from "lodash";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import classnames from "classnames";
import ModalImage from "react-modal-image";
import { api } from "../../../config";
import { Link } from "react-router-dom";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { resetProductInventoryState, getProductInventory as onGetProductInventories, addNewProductInventory as onAddNewProductInventory, updateProductInventory as onUpdateProductInventory, deleteProductInventory as onDeleteProductInventory, getProductInventoryLoading } from "../../../store/productInventory/action";
import { resetCivilBudgetControlMaterialState, getCivilBudgetControlMaterial as onGetCivilBudgetControlMaterials, addNewCivilBudgetControlMaterial as onAddNewCivilBudgetControlMaterial, updateCivilBudgetControlMaterial as onUpdateCivilBudgetControlMaterial, deleteCivilBudgetControlMaterial as onDeleteCivilBudgetControlMaterial, getCivilBudgetControlMaterialLoading } from "../../../store/civilBudgetControlMaterial/action";
import { resetCivilBudgetState, getCivilBudget as onGetCivilBudgets } from "../../../store/civilBudget/action";
import "react-toastify/dist/ReactToastify.css";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import ExportDoc from "../../../Components/Common/ExportDoc";
import SimpleBar from "simplebar-react";

const CivilBudget = () => {
  const [modalMaterial, setModalMaterial] = useState(false);
  const [modal, setModal] = useState(false);
  const [stockCard, setStockCard] = useState([]);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, civilBudgets, loading, error, civilBudgetControlMaterials, civilBudgetControlMaterialLoading, isCivilBudgetControlMaterialCreated, isCivilBudgetControlMaterialSuccess, productInventories, productInventoryLoading, } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    civilBudgets: state.CivilBudget.civilBudgets,
    loading: state.CivilBudget.loading,
    error: state.CivilBudget.error,
    civilBudgetControlMaterials: state.CivilBudgetControlMaterial.civilBudgetControlMaterials,
    civilBudgetControlMaterialLoading: state.CivilBudgetControlMaterial.loading,
    isCivilBudgetControlMaterialCreated: state.CivilBudgetControlMaterial.isCivilBudgetControlMaterialCreated,
    isCivilBudgetControlMaterialSuccess: state.CivilBudgetControlMaterial.isCivilBudgetControlMaterialSuccess,
    productInventoryLoading: state.ProductInventory.loading,
    productInventories: state.ProductInventory.productInventories,
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [civilBudgetSelectList, setCivilBudgetSelectList] = useState([]);
  const [civilBudget, setCivilBudget] = useState([]);
  const [componentControlAddedId, setComponentControlAddedId] = useState(0);
  const [civilBudgetControlMaterial, setCivilBudgetControlMaterial] = useState([]);
  const [isEdit, setIsEdit] = useState(false);

  const [budgetName, setBudgetName] = useState("");
  const [branchName, setBranchName] = useState("");
  const [startAt, setStartAt] = useState("");
  const [endAt, setEndAt] = useState("");
  const [unit, setUnit] = useState(0);
  const [content, setContent] = useState("");
  const [totalAll, setTotalAll] = useState(0);
  const [totalHrg, setTotalHrg] = useState(0);
  const [totalRealHrg, setTotalRealHrg] = useState(0);
  const [totalRealHrgAcc, setTotalRealHrgAcc] = useState(0);
  const [totalQty, setTotalQty] = useState(0);
  const [totalOut, setTotalOut] = useState(0);
  const [totalRealQty, setTotalRealQty] = useState(0);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const expanseDataRef = useRef([])
  const [expense, setExpense] = useState([]);
  const [expenseType, setExpenseType] = useState("Purchase");
  const [label, setLabel] = useState([]);
  const [controlDetail, setControlDetail] = useState([]);
  const [printDoc, setPrintDoc] = useState([]);
  const [printDetailDoc, setPrintDetailDoc] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [dataPrintDoc, setDataPrintDoc] = useState([]);
  const [activeAccordion, setActiveAccordion] = useState("");

  useEffect(() => {
    if (companySelected && branchSelected) {
      dispatch(resetCivilBudgetControlMaterialState());
      dispatch(resetCivilBudgetState());
      dispatch(onGetCivilBudgets({ companyId: companySelected.value, branchId: branchSelected.value }));
    }
  }, [companySelected, branchSelected]);

  useEffect(() => {
    if (!isEmpty(civilBudgets)) {
      setIsEdit(false);
      setCivilBudget(civilBudgets);
    }
  }, [civilBudgets, componentControlAddedId]);

  useEffect(() => {
    var data = [];
    var opt = [{ label: "SEMUA MATERIAL", value: "all", data: null }];
    civilBudgets.forEach((item, key) => {
      if (item.type === "INFRASTRUKTUR" || item.type === "BANGUNAN" || item.type === "PEKERJAAN TAMBAH 1" || item.type === "PEKERJAAN TAMBAH 2" || item.type === "PEKERJAAN TAMBAH 3" || item.type === "PEKERJAAN TAMBAH 4" || item.type === "PEKERJAAN TAMBAH 5" || item.type === "PEKERJAAN TAMBAH 6" || item.type === "PEKERJAAN TAMBAH 7" || item.type === "PEKERJAAN TAMBAH 8" || item.type === "LISTRIK JARINGAN") {
        const name = item.cvl_branch ? item.cvl_branch.name + " - " + item.name : item.name;
        const id = item.id;
        var obj = { label: name, value: id, data: item };
        opt.push(obj);
      }
    });
    var option = { options: opt };
    data.push(option);

    if (civilBudgets.length > 0) {
      setCivilBudgetSelectList(data);
    }
  }, [civilBudgets]);

  useEffect(() => {
    if (!isEmpty(productInventories)) {

      let arr = [];
      let saldo = 0;
      productInventories.sort((a, b) => new Date(a.transactionat) - new Date(b.transactionat)).forEach(pi => {
        pi.inv_detail.forEach(data => {
          let inbound = pi.transaction_status === "IN" ? parseFloat(data.quantity) : 0;
          let outbond = pi.transaction_status === "OUT" ? parseFloat(data.quantity) : 0;
          if (inbound > 0) {
            saldo = saldo + inbound;
          }
          if (outbond > 0) {
            saldo = saldo - outbond;
          }
          let obj = data;
          obj.transaction_status = pi.transaction_status;
          obj.transaction_no = pi.transaction_no;
          obj.transactionat = pi.transactionat;
          obj.inv_file = pi.inv_file;
          obj.inv_transfer = pi.inv_transfer;
          obj.inv_purchase = pi.inv_purchase;
          obj.inv_sales = pi.inv_sales;
          obj.inbound = inbound;
          obj.outbond = outbond;
          obj.saldo = saldo;
          arr.push(obj);
        });
      })
      setStockCard(arr);
    }
  }, [productInventories]);

  const toggleActiveAccordion = (el) => {
    if (el !== activeAccordion) setActiveAccordion(el);
    else setActiveAccordion("");
  };

  useEffect(() => {
    if (!isEmpty(civilBudgetControlMaterials)) {
      setCivilBudgetControlMaterial(civilBudgetControlMaterials);
      let ttlAll = 0;
      let ttlHrg = 0;
      let ttlRealHrg = 0;
      let ttlRealHrgAcc = 0;
      let ttlQty = 0;
      let ttlOut = 0;
      let ttlRealQty = 0;
      for (const d of civilBudgetControlMaterials) {
        if (d.material.length > 0) {
          for (const data of d.material) {
            ttlHrg += parseFloat(data.price);
            ttlQty += parseFloat(data.quantity);
            ttlAll += parseFloat(data.quantity) * parseFloat(data.price);

            let total_realization = data.realization.reduce((a, v) => (a = a + parseFloat(v.amount)), 0);
            let total_realization_qty = data.realization.reduce((a, v) => (a = a + parseFloat(v.quantity)), 0);
            let total_distribution = data.distribution.reduce((a, v) => (a = a + parseFloat(v.quantity)), 0);
            let total_realization_accepted = data.realization.reduce((a, v) => (a = a + (parseFloat(v.accepted || 0) * parseFloat(v.amount))), 0);
            ttlRealHrg += parseFloat(total_realization);
            ttlRealHrgAcc += parseFloat(total_realization_accepted);
            ttlRealQty += parseFloat(total_realization_qty);
            ttlOut += parseFloat(total_distribution);
          }
        }
      }

      setTotalAll(ttlAll);
      setTotalHrg(ttlHrg);
      setTotalRealHrg(ttlRealHrg);
      setTotalRealHrgAcc(ttlRealHrgAcc);
      setTotalQty(ttlQty);
      setTotalOut(ttlOut);
      setTotalRealQty(ttlRealQty);
      setControlDetail(civilBudgetControlMaterials.map((el) => ({ ...el, isChecked: true })));
    } else {
      setControlDetail([]);
    }
  }, [civilBudgetControlMaterials, civilBudgetControlMaterialLoading]);

  const toggleMaterial = useCallback(() => {
    if (modalMaterial) {
      setModalMaterial(false);
    } else {
      setModalMaterial(true);
    }
  }, [modalMaterial]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }
  }, [modal]);

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteCivilBudgetControlMaterial(element.value));
    });
    checkall.checked = false;
  };

  function currencyFormat(num) {
    return parseFloat(Math.round(num)).toLocaleString(["ban", "id"]);
  }

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "URAIAN PEKERJAAN",
        isSelected: true,
        data: [],
      },
      {
        id: "quantity",
        label: "VOL",
        isSelected: true,
        data: [],
      },
      {
        id: "uom",
        label: "SATUAN",
        isSelected: true,
        data: [],
      },
      {
        id: "price",
        label: "HARGA",
        isSelected: true,
        data: [],
      },
      {
        id: "unit",
        label: "UNIT",
        isSelected: true,
        data: [],
      },
      {
        id: "total",
        label: "TOTAL RAB",
        isSelected: true,
        data: [],
      },
      {
        id: "total_realization",
        label: "REALISASI HRG",
        isSelected: true,
        data: [],
      },
      {
        id: "realization_value",
        label: "SELISIH HRG",
        isSelected: true,
        data: [],
      },
      {
        id: "total_volume",
        label: "TOTAL VOLUME RAB",
        isSelected: true,
        data: [],
      },
      {
        id: "total_realization_qty",
        label: "REALISASI QTY",
        isSelected: true,
        data: [],
      },
      {
        id: "realization_qty",
        label: "SELISIH QTY RAB VS REALISASI",
        isSelected: true,
        data: [],
      },
      {
        id: "total_out",
        label: "PENGELUARAN BARANG",
        isSelected: true,
        data: [],
      },
    ];
    if (controlDetail.length > 0) {

      controlDetail.forEach((control) => {
        let doc = dataDoc.find((d) => d.id === "name");
        if (doc) doc.data.push(control?.name);

        doc = dataDoc.find((d) => d.id === "quantity");
        if (doc) doc.data.push("");

        doc = dataDoc.find((d) => d.id === "uom");
        if (doc) doc.data.push("");

        doc = dataDoc.find((d) => d.id === "price");
        if (doc) doc.data.push("");

        doc = dataDoc.find((d) => d.id === "unit");
        if (doc) doc.data.push("");

        doc = dataDoc.find((d) => d.id === "total");
        if (doc) doc.data.push("");

        doc = dataDoc.find((d) => d.id === "total_realization");
        if (doc) doc.data.push("");

        doc = dataDoc.find((d) => d.id === "realization_value");
        if (doc) doc.data.push("");

        doc = dataDoc.find((d) => d.id === "total_volume");
        if (doc) doc.data.push("");

        doc = dataDoc.find((d) => d.id === "total_realization_qty");
        if (doc) doc.data.push("");

        doc = dataDoc.find((d) => d.id === "realization_qty");
        if (doc) doc.data.push("");

        (control.material || []).sort((a, b) => a?.name?.localeCompare(b?.name, undefined, { numeric: true, sensitivity: 'base' })).forEach((item, idx) => {

          let total_realization = item.realization.reduce((a, v) => (a = a + (parseFloat(v.accepted || 0) * parseFloat(v.amount))), 0);
          let total_realization_qty = item.realization.reduce((a, v) => (a = a + parseFloat(v.quantity)), 0);
          let total_realization_acc = item.realization.reduce((a, v) => (a = a + parseFloat(v.accepted || 0)), 0);
          let total_out = item.distribution.reduce((a, v) => (a = a + parseFloat(v.quantity)), 0);
          let realization = (item.price * item.quantity * unit) - total_realization;
          let realization_qty = item.quantity * unit - item.realization.reduce((a, v) => (a = a + parseFloat(v.quantity)), 0);
          let total_realization_accepted = item.realization.reduce((a, v) => (a = a + (parseFloat(v.accepted || 0) * parseFloat(v.amount))), 0);
          let total_rab = parseFloat(item.quantity) * parseFloat(item.price) * unit;
          let total_rab_vol = parseFloat(item.quantity) * unit;
          if (content === "all") {
            realization = (item.price * item.quantity) - total_realization;
            realization_qty = item.quantity - item.realization.reduce((a, v) => (a = a + parseFloat(v.quantity)), 0);
            total_realization_accepted = item.realization.reduce((a, v) => (a = a + (parseFloat(v.accepted || 0) * parseFloat(v.amount))), 0);
            total_rab = parseFloat(item.quantity) * parseFloat(item.price);
            total_rab_vol = parseFloat(item.quantity);
          }

          doc = dataDoc.find((d) => d.id === "name");
          if (doc) doc.data.push(item.name);

          doc = dataDoc.find((d) => d.id === "quantity");
          if (doc) doc.data.push(item?.quantity);

          doc = dataDoc.find((d) => d.id === "uom");
          if (doc) doc.data.push(item?.uom);

          doc = dataDoc.find((d) => d.id === "price");
          if (doc) doc.data.push(item?.price);

          doc = dataDoc.find((d) => d.id === "unit");
          if (doc) doc.data.push(unit);

          doc = dataDoc.find((d) => d.id === "total");
          if (doc) doc.data.push(total_rab);

          doc = dataDoc.find((d) => d.id === "total_realization");
          if (doc) doc.data.push(total_realization);

          doc = dataDoc.find((d) => d.id === "realization_value");
          if (doc) doc.data.push(realization);

          doc = dataDoc.find((d) => d.id === "total_volume");
          if (doc) doc.data.push(total_rab_vol);

          doc = dataDoc.find((d) => d.id === "total_realization_qty");
          if (doc) doc.data.push(total_realization_acc);

          doc = dataDoc.find((d) => d.id === "realization_qty");
          if (doc) doc.data.push(realization_qty);

          doc = dataDoc.find((d) => d.id === "total_out");
          if (doc) doc.data.push(total_out);
        });
      });
    }
    setDataPrintDoc(dataDoc);
  }, [controlDetail, unit, content]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Pembelian",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "transactionat",
        label: "Tgl Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "Harga Beli",
        isSelected: true,
        data: [],
      },
      {
        id: "quantity",
        label: "Qty",
        isSelected: true,
        data: [],
      },
      {
        id: "accepted",
        label: "Terima",
        isSelected: true,
        data: [],
      },
      {
        id: "total_amount",
        label: "Total",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (expense.length > 0) {
      expense.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);

            if (doc) {
              if (doc.id === "transactionat") {
                doc.data.push(handleValidDate(value));
              } else if (doc.id === "amount" || doc.id === "quantity" || doc.id === "total_amount" || doc.id === "accepted") {
                doc.data.push(currencyFormat(parseFloat(value || 0) || 0));
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDetailDoc(dataDoc);
  }, [expense]);

  const sumRealization = (element) => {
    let total = 0;
    for (const el of element)
      total += el.realization.reduce((a, v) => (a = a + (parseFloat(v.accepted || 0) * parseFloat(v.amount))), 0);
    return currencyFormat(total);
  };

  const sumRestRealization = (element) => {
    let total = 0;
    for (const el of element) {
      let total_realization = el.realization.reduce((a, v) => (a = a + (parseFloat(v.accepted || 0) * parseFloat(v.amount))), 0);
      total += (el.price * el.quantity * unit) - total_realization;
    }
    return currencyFormat(total);
  };

  const sumRestAllRealization = (element) => {
    let total = 0;
    for (const el of element) {
      let total_realization = el.realization.reduce((a, v) => (a = a + (parseFloat(v.accepted || 0) * parseFloat(v.amount))), 0);
      total += (el.price * el.quantity) - total_realization;
    }
    return currencyFormat(total);
  };

  const searchList = (e) => {
    let inputVal = e.toLowerCase();

    const filterItems = (arr, query) => {
      return arr.filter((el) => {
        return (el.name ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.description ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.transaction_no ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.quantity ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.amount ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.accepted ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1;
      });
    };

    let filterData = filterItems(expanseDataRef.current, inputVal);
    filterData.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));

    setExpense(filterData);
  };

  document.title = "Cost Control Material | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title="Teknik" pageTitle="Cost Control Material" loading={loading || civilBudgetControlMaterialLoading} />
        <Row>
          <Col sm={12}>
            <Card>
              <div className="card-body d-flex align-items-center">
                <div className="mb-2 flex-grow-1">
                  <h5 className="text-uppercase">
                    Pengawasan Biaya
                  </h5>
                  <h3 className="mb-1 text-uppercase text-success">{budgetName}</h3>
                  <p className="mb-1 fs-14 fw-semibold text-uppercase">{branchName}</p>
                  {content !== "all" && <p className="mb-1 fs-14 fw-semibold text-uppercase">JUMLAH {unit} UNIT</p>}
                </div>
                <div className="flex-shrink-0">
                  <div className="flex-shrink-0">
                    <div
                      className="mb-3 d-flex"
                      style={{
                        position: "relative",
                        width: "680px",
                        zIndex: 1000,
                      }}
                    >
                      <div className="search-box me-2 mb-3">
                        <Flatpickr
                          className="form-control"
                          id="datepicker-publish-input"
                          placeholder="Pilih Tanggal"
                          value={filterDate}
                          options={{
                            mode: "range",
                            dateFormat: "Y/m/d",
                          }}
                          onChange={(selectedDates, dateStr) => {
                            setFilterDate(dateStr);
                          }}
                        />
                        <i className="bx bx-calendar-alt search-icon"></i>
                      </div>
                      <div className="flex-grow me-2" style={{ width: "360px" }}>
                        <Select
                          name="branch"
                          className="text-uppercase w-100"
                          placeholder=" Pilih Aggaran Proyek"
                          style={{ position: "absolute" }}
                          onChange={(e) => {
                            //handleCivilBudgetClick(e.data);
                            setContent(e.value);
                            if (e.value === "all") {
                              setBudgetName("KEBUTUHAN MATERIAL SEMUA ANGGARAN");
                              if (filterDate) {
                                let datearr = filterDate?.split(" to ");
                                if (datearr) {
                                  dispatch(
                                    onGetCivilBudgetControlMaterials({
                                      civilBudgetId: e.value, companyId: companySelected.value, branchId: branchSelected.value, startat: datearr[0], endat: datearr[1] ? datearr[1] : datearr[0]
                                    })
                                  );
                                }
                              } else {
                                dispatch(
                                  onGetCivilBudgetControlMaterials({
                                    civilBudgetId: e.value, companyId: companySelected.value, branchId: branchSelected.value,
                                  })
                                );
                              }
                            }
                            else {
                              setCivilBudget(e.data);
                              setBranchName(e.data.cvl_branch.name);
                              setUnit(parseInt(e.data.unit));
                              setBudgetName(e.data.name);
                              setStartAt(e.data.startat);
                              setEndAt(e.data.endat);
                              dispatch(resetCivilBudgetControlMaterialState());
                              if (filterDate) {
                                let datearr = filterDate?.split(" to ");
                                if (datearr) {
                                  dispatch(
                                    onGetCivilBudgetControlMaterials({
                                      civilBudgetId: e.value, startat: datearr[0], endat: datearr[1] ? datearr[1] : datearr[0]
                                    })
                                  );
                                }
                              } else {
                                dispatch(
                                  onGetCivilBudgetControlMaterials({
                                    civilBudgetId: e.value
                                  })
                                );
                              }
                            }
                          }}
                          options={civilBudgetSelectList}></Select>
                      </div>
                      {controlDetail.length > 0 && (
                        <div className="flex-shrink-0">
                          <ExportDoc data={dataPrintDoc} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {content !== "all" ?
                <div className="card-body">
                  <div className="table-responsive table-card tableFixHead mb-0 mt-3">
                    {controlDetail.length > 0 && (
                      <Table className="table-border text-center table-hover table-nowrap align-middle mb-0">
                        <thead>
                          <tr className="bg-white">
                            <th scope="col" className="text-start fs-14 bg-light text-muted"> URAIAN PEKERJAAN</th>
                            <th scope="col" className="text-center bg-light text-muted">VOL</th>
                            <th scope="col" className="text-center bg-light text-muted">SATUAN</th>
                            <th scope="col" className="text-end bg-light pe-1 text-muted">HARGA</th>
                            <th scope="col" className="text-end text-white bg-info">HARGA RAB</th>
                            <th scope="col" className="text-end text-white bg-info d-none">REALISASI PESANAN</th>
                            <th scope="col" className="text-end text-white bg-info">REALISASI</th>
                            <th scope="col" className="text-end text-white bg-info">SELISIH</th>
                            <th scope="col" className="text-end text-white bg-primary">VOL RAB</th>
                            <th scope="col" className="text-end text-white bg-primary">PESANAN</th>
                            <th scope="col" className="text-end text-white bg-primary">TERIMA</th>
                            {/* <th scope="col" className="text-end text-white bg-primary" style={{ width: "80px" }}>STOK</th> */}
                            <th scope="col" className="text-end text-white bg-primary" style={{ width: "80px" }}>SELISIH</th>
                            <th scope="col" className="text-end text-white bg-primary" style={{ width: "80px" }}>PENGELUARAN</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(controlDetail || []).map((element, index) => {
                            return (
                              <Fragment key={index}>
                                <tr>
                                  <th colSpan={4} className="text-start fs-14">{element.name}</th>
                                  <td className="text-end fw-semibold pe-2 fs-14">{currencyFormat(element.material.reduce((a, v) => (a = a + (parseFloat(v.quantity) * parseFloat(v.price) * unit)), 0))}</td>
                                  <td className="text-end fw-semibold pe-2 fs-14 text-info">{sumRealization(element.material)}</td>
                                  <td className={sumRestRealization(element.material) < 1 ? "text-end fw-semibold pe-2 fs-14 text-danger" : "text-end fw-semibold pe-2 fs-14 text-success"}>{sumRestRealization(element.material)}</td>
                                  <td colSpan={6}></td>
                                </tr>
                                {(element.material || []).sort((a, b) => a?.name?.localeCompare(b?.name, undefined, { numeric: true, sensitivity: 'base' })).map((el, idx) => {
                                  let total_realization = el.realization.reduce((a, v) => (a = a + (parseFloat(v.accepted || 0) * parseFloat(v.amount))), 0);
                                  let total_realization_qty = el.realization.reduce((a, v) => (a = a + parseFloat(v.quantity)), 0);
                                  let total_realization_acc = el.realization.reduce((a, v) => (a = a + parseFloat(v.accepted || 0)), 0);
                                  let realization = (el.price * el.quantity * unit) - total_realization;
                                  let realization_qty = el.quantity * unit - el.realization.reduce((a, v) => (a = a + parseFloat(v.quantity)), 0);
                                  let total_realization_accepted = el.realization.reduce((a, v) => (a = a + (parseFloat(v.accepted || 0) * parseFloat(v.amount))), 0);
                                  let total_out = el.distribution.reduce((a, v) => (a = a + parseFloat(v.quantity)), 0);

                                  return (<tr key={idx} className="pb-4">
                                    <td className="text-start"><i className="ms-3"></i> {el.name}</td>
                                    <td className="text-center fw-semibold">{parseFloat(el.quantity)}</td>
                                    <td className="text-center">{el.uom}</td>
                                    <td className="text-end pe-2">{currencyFormat(el.price || 0)}</td>
                                    <td className="text-end fw-semibold bg-soft-info border-bottom border-opacity-25 border-info">{currencyFormat(parseFloat(el.quantity) * parseFloat(el.price) * unit)}</td>
                                    <td className="text-end text-info bg-soft-info fw-semibold border-opacity-25 border-info d-none">
                                      <em
                                        className="fw-semibold text-info"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          expanseDataRef.current = el.realization
                                          setLabel(el.name);
                                          setExpense(el.realization);
                                          setExpenseType("Purchase");
                                          toggleMaterial();
                                        }}>
                                        {currencyFormat(total_realization || 0)}
                                      </em>
                                    </td>
                                    <td className="text-end text-info bg-soft-info fw-semibold border-opacity-25 border-info">
                                      <em
                                        className="fw-semibold text-info"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          expanseDataRef.current = el.realization
                                          setLabel(el.name);
                                          setExpense(el.realization);
                                          setExpenseType("Purchase");
                                          toggleMaterial();
                                        }}>
                                        {currencyFormat(total_realization_accepted || 0)}
                                      </em>
                                    </td>
                                    <td className={realization < 1 ? "text-end border-bottom border-opacity-25 border-danger bg-soft-danger text-info fw-semibold text-danger" : "text-end border-bottom border-success border-opacity-25 bg-soft-success text-success fw-semibold"}>{currencyFormat(realization || 0)}</td>
                                    <td className="text-end fw-semibold bg-soft-primary border-bottom border-opacity-25 border-primary">{currencyFormat(parseFloat(el.quantity) * unit)}</td>
                                    <td className="text-end text-info bg-soft-primary border-bottom border-opacity-25 border-primary">
                                      <em
                                        className="fw-semibold text-info"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          expanseDataRef.current = el.realization
                                          setLabel(el.name);
                                          setExpense(el.realization);
                                          setExpenseType("Purchase");
                                          toggleMaterial();
                                        }}>
                                        {parseFloat(total_realization_qty).toFixed(2).replace(".", ",")}
                                      </em>
                                    </td>
                                    <td className="text-end text-info bg-soft-primary border-bottom border-opacity-25 border-primary">
                                      <em
                                        className="fw-semibold text-info"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          expanseDataRef.current = el.realization
                                          setLabel(el.name);
                                          setExpense(el.realization);
                                          setExpenseType("Purchase");
                                          toggleMaterial();
                                        }}>
                                        {parseFloat(total_realization_acc).toFixed(2).replace(".", ",")}
                                      </em>
                                    </td>
                                    {/* <td className={"text-end fw-semibold bg-soft-primary border-bottom border-opacity-25 border-primary"}>{parseFloat(el.stock || 0).toFixed(2).replace(".", ",")}</td> */}
                                    <td className={realization_qty < 1 ? "text-end border-bottom border-opacity-25 border-danger bg-soft-danger text-info fw-semibold text-danger" : "text-end border-bottom border-success border-opacity-25 bg-soft-success text-success fw-semibold"}>{currencyFormat(realization_qty || 0)}</td>
                                    <td className="text-end text-info bg-soft-primary border-bottom border-opacity-25 border-primary">
                                      <em
                                        className="fw-semibold text-info"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          expanseDataRef.current = el.distribution
                                          setLabel(el.name);
                                          setExpense(el.distribution);
                                          setExpenseType("Distribution");
                                          toggleMaterial();
                                        }}>
                                        {parseFloat(total_out).toFixed(2).replace(".", ",")}
                                      </em>
                                    </td>

                                  </tr>)
                                })
                                }
                              </Fragment>)

                          })}
                        </tbody>
                        <tfoot>
                          <tr className="table-active">
                            {/* <th scope="col" className="text-center pt-3 pb-4" style={{ background: "#FFFFFF", left: "0px", zIndex: 101 }}><div style={{ width: "200px" }}></div></th> */}
                            <th
                              scope="col"
                              className="text-center pt-3 pb-4"
                              style={{
                                background: "#FFFFFF",
                                left: "0px",
                                zIndex: 101,
                              }}>
                              <div style={{ width: "200px" }}>TOTAL</div>
                            </th>
                            <th scope="col" className="text-center pt-3 pb-4 fs-14"></th>
                            <th scope="col" className="text-center pt-3 pb-4 fs-14"></th>
                            <th scope="col" className="text-end pt-3 pb-4 fs-14">{currencyFormat(totalHrg || 0)}</th>
                            <th scope="col" className="text-end text-primary pt-3 pb-4 fs-14">{currencyFormat(totalAll * unit || 0)}</th>
                            <th scope="col" className="text-end text-info pt-3 pb-4 fs-14 d-none">{currencyFormat(totalRealHrg || 0)}</th>
                            <th scope="col" className="text-end text-info pt-3 pb-4 fs-14">{currencyFormat(totalRealHrgAcc || 0)}</th>
                            <th scope="col" className="text-end text-primary pt-3 pb-4 fs-14" >{currencyFormat((totalAll * unit) - totalRealHrgAcc)}</th>
                            <th scope="col" className="text-end pt-3 pb-4 fs-14"></th>
                            <th scope="col" className="text-end text-info pt-3 pb-4 fs-14"></th>
                            <th scope="col" className="text-end text-info pt-3 pb-4 fs-14"></th>
                            {/* <th scope="col" className="text-end text-info pt-3 pb-4 fs-14"></th> */}
                            <th scope="col" className="text-end text-info pt-3 pb-4 fs-14"></th>
                            <th scope="col" className="text-end text-info pt-3 pb-4 fs-14"></th>
                          </tr>
                        </tfoot>
                      </Table>
                    )}
                  </div>
                </div>
                :
                <div className="card-body">
                  <div className="table-responsive table-card tableFixHead mb-0 mt-3">
                    {controlDetail.length > 0 && (
                      <Table className="table-border text-center table-hover table-nowrap align-middle mb-0">
                        <thead>
                          <tr className="bg-white">
                            <th scope="col" className="text-start fs-14 bg-light text-muted"> URAIAN PEKERJAAN</th>
                            <th scope="col" className="text-center bg-light text-muted">VOL</th>
                            <th scope="col" className="text-center bg-light text-muted">SATUAN</th>
                            <th scope="col" className="text-end bg-light pe-1 text-muted">HARGA</th>
                            <th scope="col" className="text-end text-white bg-info">HARGA RAB</th>
                            <th scope="col" className="text-end text-white bg-info d-none">REALISASI PESANAN</th>
                            <th scope="col" className="text-end text-white bg-info">REALISASI</th>
                            <th scope="col" className="text-end text-white bg-info">SELISIH</th>
                            <th scope="col" className="text-end text-white bg-primary">VOL RAB</th>
                            <th scope="col" className="text-end text-white bg-primary">PESANAN</th>
                            <th scope="col" className="text-end text-white bg-primary">TERIMA</th>
                            {/* <th scope="col" className="text-end text-white bg-primary" style={{ width: "80px" }}>STOK</th> */}
                            <th scope="col" className="text-end text-white bg-primary" style={{ width: "80px" }}>SELISIH</th>
                            <th scope="col" className="text-end text-white bg-primary" style={{ width: "80px" }}>PENGELUARAN</th>
                            <th scope="col" className="text-end text-white bg-primary" style={{ width: "80px" }}>STOK</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(controlDetail || []).map((element, index) => {
                            return (
                              <Fragment key={index}>
                                <tr>
                                  <th colSpan={4} className="text-start fs-14">{element.name}</th>
                                  <td className="text-end fw-semibold pe-2 fs-14">{currencyFormat(element.material.reduce((a, v) => (a = a + (parseFloat(v.quantity) * parseFloat(v.price))), 0))}</td>
                                  <td className="text-end fw-semibold pe-2 fs-14 text-info">{sumRealization(element.material)}</td>
                                  <td className={sumRestAllRealization(element.material) < 1 ? "text-end fw-semibold pe-2 fs-14 text-danger" : "text-end fw-semibold pe-2 fs-14 text-success"}>{sumRestAllRealization(element.material)}</td>
                                  <td colSpan={6}></td>
                                </tr>
                                {(element.material || []).sort((a, b) => a?.name?.localeCompare(b?.name, undefined, { numeric: true, sensitivity: 'base' })).map((el, idx) => {
                                  let total_realization = el.realization.reduce((a, v) => (a = a + (parseFloat(v.accepted || 0) * parseFloat(v.amount))), 0);
                                  let total_realization_qty = el.realization.reduce((a, v) => (a = a + parseFloat(v.quantity)), 0);
                                  let total_realization_acc = el.realization.reduce((a, v) => (a = a + parseFloat(v.accepted || 0)), 0);
                                  let realization = (el.price * el.quantity) - total_realization;
                                  let realization_qty = el.quantity - el.realization.reduce((a, v) => (a = a + parseFloat(v.quantity)), 0);
                                  let total_realization_accepted = el.realization.reduce((a, v) => (a = a + (parseFloat(v.accepted || 0) * parseFloat(v.amount))), 0);
                                  let total_out = el.distribution.reduce((a, v) => (a = a + parseFloat(v.quantity)), 0);

                                  return (<tr key={idx} className="pb-4">
                                    <td className="text-start"><i className="ms-3"></i> {el.name}</td>
                                    <td className="text-center fw-semibold">{parseFloat(el.quantity).toFixed(2)}</td>
                                    <td className="text-center">{el.uom}</td>
                                    <td className="text-end pe-2">{currencyFormat(el.price || 0)}</td>
                                    <td className="text-end fw-semibold bg-soft-info border-bottom border-opacity-25 border-info">{currencyFormat(parseFloat(el.quantity) * parseFloat(el.price))}</td>
                                    <td className="text-end text-info bg-soft-info fw-semibold border-opacity-25 border-info d-none">
                                      <em
                                        className="fw-semibold text-info"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          expanseDataRef.current = el.realization
                                          setLabel(el.name);
                                          setExpense(el.realization);
                                          setExpenseType("Purchase");
                                          toggleMaterial();
                                        }}>
                                        {currencyFormat(total_realization || 0)}
                                      </em>
                                    </td>
                                    <td className="text-end text-info bg-soft-info fw-semibold border-opacity-25 border-info">
                                      <em
                                        className="fw-semibold text-info"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          expanseDataRef.current = el.realization
                                          setLabel(el.name);
                                          setExpense(el.realization);
                                          setExpenseType("Purchase");
                                          toggleMaterial();
                                        }}>
                                        {currencyFormat(total_realization_accepted || 0)}
                                      </em>
                                    </td>
                                    <td className={realization < 1 ? "text-end border-bottom border-opacity-25 border-danger bg-soft-danger text-info fw-semibold text-danger" : "text-end border-bottom border-success border-opacity-25 bg-soft-success text-success fw-semibold"}>{currencyFormat(realization || 0)}</td>
                                    <td className="text-end fw-semibold bg-soft-primary border-bottom border-opacity-25 border-primary">{currencyFormat(parseFloat(el.quantity))}</td>
                                    <td className="text-end text-info bg-soft-primary border-bottom border-opacity-25 border-primary">
                                      <em
                                        className="fw-semibold text-info"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          expanseDataRef.current = el.realization
                                          setLabel(el.name);
                                          setExpense(el.realization);
                                          toggleMaterial();
                                        }}>
                                        {parseFloat(total_realization_qty).toFixed(2).replace(".", ",")}
                                      </em>
                                    </td>
                                    <td className="text-end text-info bg-soft-primary border-bottom border-opacity-25 border-primary">
                                      <em
                                        className="fw-semibold text-info"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          expanseDataRef.current = el.realization
                                          setLabel(el.name);
                                          setExpense(el.realization);
                                          setExpenseType("Purchase");
                                          toggleMaterial();
                                        }}>
                                        {parseFloat(total_realization_acc).toFixed(2).replace(".", ",")}
                                      </em>
                                    </td>
                                    {/* <td className={"text-end fw-semibold bg-soft-primary border-bottom border-opacity-25 border-primary"}>{parseFloat(el.stock || 0).toFixed(2).replace(".", ",")}</td> */}
                                    <td className={realization_qty < 1 ? "text-end border-bottom border-opacity-25 border-danger bg-soft-danger text-info fw-semibold text-danger" : "text-end border-bottom border-success border-opacity-25 bg-soft-success text-success fw-semibold"}>{currencyFormat(realization_qty || 0)}</td>
                                    <td className="text-end text-info bg-soft-primary border-bottom border-opacity-25 border-primary">
                                      <em
                                        className="fw-semibold text-info"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          expanseDataRef.current = el.distribution
                                          setLabel(el.name);
                                          setExpense(el.distribution);
                                          setExpenseType("Distribution");
                                          toggleMaterial();
                                        }}>
                                        {parseFloat(total_out).toFixed(2).replace(".", ",")}
                                      </em>
                                    </td>
                                    <td className="text-end fw-semibold bg-soft-primary border-bottom border-opacity-25 border-primary cursor-pointer" onClick={() => {
                                      dispatch(onGetProductInventories({ type: "inventory", branchId: branchSelected?.value ?? "", productId: el.productId }));
                                      setStockCard([]);
                                      toggle();
                                    }}>{currencyFormat(parseFloat(el.stock))}</td>
                                  </tr>)
                                })
                                }
                              </Fragment>)

                          })}
                        </tbody>
                        <tfoot>
                          <tr className="table-active">
                            {/* <th scope="col" className="text-center pt-3 pb-4" style={{ background: "#FFFFFF", left: "0px", zIndex: 101 }}><div style={{ width: "200px" }}></div></th> */}
                            <th
                              scope="col"
                              className="text-center pt-3 pb-4"
                              style={{
                                background: "#FFFFFF",
                                left: "0px",
                                zIndex: 101,
                              }}>
                              <div style={{ width: "200px" }}>TOTAL</div>
                            </th>
                            <th scope="col" className="text-center pt-3 pb-4 fs-14"></th>
                            <th scope="col" className="text-center pt-3 pb-4 fs-14"></th>
                            <th scope="col" className="text-end pt-3 pb-4 fs-14">{currencyFormat(totalHrg || 0)}</th>
                            <th scope="col" className="text-end text-primary pt-3 pb-4 fs-14">{currencyFormat(totalAll || 0)}</th>
                            <th scope="col" className="text-end text-info pt-3 pb-4 fs-14 d-none">{currencyFormat(totalRealHrg || 0)}</th>
                            <th scope="col" className="text-end text-info pt-3 pb-4 fs-14">{currencyFormat(totalRealHrgAcc || 0)}</th>
                            <th scope="col" className="text-end text-primary pt-3 pb-4 fs-14" >{currencyFormat((totalAll) - totalRealHrgAcc)}</th>
                            <th scope="col" className="text-end pt-3 pb-4 fs-14"></th>
                            <th scope="col" className="text-end text-info pt-3 pb-4 fs-14"></th>
                            <th scope="col" className="text-end text-info pt-3 pb-4 fs-14"></th>
                            {/* <th scope="col" className="text-end text-info pt-3 pb-4 fs-14"></th> */}
                            <th scope="col" className="text-end text-info pt-3 pb-4 fs-14"></th>
                            <th scope="col" className="text-end text-info pt-3 pb-4 fs-14"></th>
                            <th scope="col" className="text-end text-info pt-3 pb-4 fs-14"></th>
                          </tr>
                        </tfoot>
                      </Table>
                    )}
                  </div>
                </div>
              }
            </Card>
          </Col>
        </Row>
        <Modal id="showModal" isOpen={modalMaterial} centered size="xl">
          <ModalHeader className="bg-light p-3" toggleMaterial={toggleMaterial}>DETAIL REALISASI ANGGARAN {label}</ModalHeader>
          <ModalBody>
            <CardBody>
              <div>
                <Row className="m-0 p-0 pb-3 border border-top-0 border-end-0 border-start-0">
                  <div className="col-sm-10">
                    <Row className="m-0 p-0 ">
                      <div className="fw-semibold col-sm-5 text-start">
                        <input className="search-box  w-100 form-control" placeholder="Filter ..." onChange={(e) => searchList(e.target.value)} />
                      </div>
                    </Row>
                  </div>
                  <div className="col-sm-2 text-end"><ExportDoc data={printDetailDoc} /></div>
                </Row>
                <SimpleBar style={{ height: "380px" }}>
                  <Table className="table-border text-center table-hover table-nowrap align-middle mb-0">
                    <thead className="align-middle">
                      <tr className="table-active bg-soft-info">
                        <th style={{ width: "20px" }}>
                          <input
                            type="checkbox"
                            className="checkboxDetailAll me-2 form-check-input"
                            checked={expense.every((item) => item.isChecked)}
                            onChange={() => {
                              const allChecked = expense.every((item) => item.isChecked);
                              const updatedData = expense.map((item) => ({
                                ...item,
                                isChecked: !allChecked,
                              }));
                              setExpense(updatedData);
                            }} />
                        </th>
                        <th className="text-start">Nama Material</th>
                        <th className="text-center" style={{ width: "170px" }}>No Transaksi</th>
                        <th className="text-center" style={{ width: "170px" }}>Tanggal</th>
                        <th className="text-center" style={{ width: "170px" }}>{expenseType === "Purchase" ? "Harga" : "Jenis"}</th>
                        <th className="text-center" style={{ width: "170px" }}>Jumlah</th>
                        {
                          expenseType === "Purchase" &&
                          <Fragment>
                            <th className="text-center" style={{ width: "170px" }}>Terima</th>
                            <th className="text-center" style={{ width: "150px" }}>Total</th>
                          </Fragment>
                        }
                        <th className="text-start" style={{ width: "150px" }}>Keterangan</th>
                      </tr>
                      <tr className="bg-light border-bottom">
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th className="text-info">{currencyFormat((expense || []).reduce((a, v) => (a = a + parseFloat(v.quantity || 0)), 0))}</th>
                        {
                          expenseType === "Purchase" &&
                          <Fragment>
                            <th className="text-info">{currencyFormat((expense || []).reduce((a, v) => (a = a + parseFloat(v.accepted || 0)), 0))}</th>
                            <th className="text-info">{currencyFormat((expense || []).reduce((a, v) => (a = a + (parseFloat(v.quantity) * parseFloat(v.amount))), 0))}</th>
                          </Fragment>
                        }
                        <th></th>
                      </tr>

                    </thead>
                    <tbody id="newlink">
                      {(expense || []).map((o, i) => {
                        return (
                          <tr key={i} id={i} className="product">
                            <td className="product-id">
                              <input
                                type="checkbox"
                                className="checkboxDetail me-2 form-check-input"
                                checked={o.isChecked}
                                onChange={() => {
                                  const updatedData = expense.map((d) => (d.id === o.id ? { ...d, isChecked: !d.isChecked } : d));
                                  setExpense(updatedData);
                                }} /> {i + 1}
                            </td>
                            <td className="text-start">{o.name}</td>
                            <td className="text-center">{o.transaction_no}</td>
                            <td className="text-center">{handleValidDate(o.transactionat)}</td>
                            <td className="text-center">{expenseType === "Purchase" ? currencyFormat(parseFloat(o.amount)) : o.type}</td>
                            <td className="text-center">{parseFloat(o.quantity ?? 0)}</td>
                            {
                              expenseType === "Purchase" &&
                              <Fragment>
                                <td className="text-center">{parseFloat(o.accepted ?? 0)}</td>
                                <td className="text-center fw-semibold">{currencyFormat(parseFloat(o.quantity) * parseFloat(o.amount))}</td>
                              </Fragment>
                            }
                            <td className="text-start">{o.description}</td>
                          </tr>
                        );
                      })}
                      {expense.length === 0 && (
                        <tr>
                          <td colSpan="8" className="p-3 text-center">
                            Belum ada realisasi
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </SimpleBar>
              </div>
            </CardBody>
          </ModalBody>
          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  setModalMaterial(false);
                }}>
                TUTUP
              </button>
            </div>
          </div>
        </Modal>
        <Modal id="showModal" isOpen={modal} centered size="xl">
          <ModalHeader className="bg-light p-3" toggle={toggle}>
            MUTASI KARTU GUDANG
            {productInventoryLoading && <>
              <Spinner color="primary" type="grow" size={"sm"}>
                Loading...
              </Spinner>
              &nbsp;
              <Spinner color="success" type="grow" size={"sm"}>
                Loading...
              </Spinner>
              &nbsp;
            </>}
          </ModalHeader>
          <ModalBody>
            <CardBody className="border-top border-top-dashed">
              <SimpleBar style={{ height: "520px" }}>
                <Table className="table-border text-center table-nowrap align-middle mb-0" style={{ position: "relative" }}>
                  <thead className="align-middle" style={{ position: "sticky", top: "0px", zIndex: "1", backgroundColor: "#FFFFFF" }}>
                    <tr className="bg-soft-info">
                      <td style={{ width: "20px" }}>
                        <input
                          type="checkbox"
                          className="checkboxDetailAll me-2 form-check-input"
                          checked={stockCard.every((item) => item.isChecked)}
                          onChange={() => {
                            const allChecked = stockCard.every((item) => item.isChecked);
                            const updatedData = stockCard.map((item) => {
                              return {
                                ...item,
                                isChecked: !allChecked,
                              };
                            });
                            setStockCard(updatedData);
                          }}
                        />
                      </td>
                      <td className="text-start">Produk</td>
                      <td className="text-center" style={{ width: "100px" }}>
                        Tanggal
                      </td>
                      <td className="text-center" style={{ width: "120px" }}>
                        No Transaksi
                      </td>
                      <td className="text-center">Status</td>
                      <td className="text-center" style={{ width: "100px" }}>
                        Inbound
                      </td>
                      <td className="text-center" style={{ width: "100px" }}>
                        Outbound
                      </td>
                      <td className="text-center" style={{ width: "100px" }}>
                        Saldo Stok
                      </td>
                      <td className="text-center">Keterangan</td>
                    </tr>
                    <tr className="bg-light border-bottom">
                      <th></th>
                      <th className="text-start text-info" colSpan={4}>
                        TOTAL
                      </th>
                      <th className="text-info">{(stockCard || []).reduce((a, v) => (a = a + parseFloat(v.inbound || 0)), 0).toFixed(2)}</th>
                      <th className="text-info">{(stockCard || []).reduce((a, v) => (a = a + parseFloat(v.outbond || 0)), 0).toFixed(2)}</th>
                      <th className="text-info">{(stockCard || []).reduce((a, v) => (v.transaction_status === "IN" ? a = a + parseFloat(v.quantity || 0) : a = a - parseFloat(v.quantity || 0)), 0).toFixed(2)}</th>
                      <th className="text-info"></th>
                    </tr>
                  </thead>
                  <tbody id="newlink">
                    {(stockCard || [])
                      .map((o, i) => {
                        let status = "";
                        switch (o.transaction_status) {
                          case "IN":
                            status = <span className="badge text-uppercase badge-soft-success me-2">{o.transaction_status}</span>;
                            break;
                          case "OUT":
                            status = <span className="badge text-uppercase badge-soft-danger me-2">{o.transaction_status}</span>;
                            break;
                          default:
                            status = <span className="badge text-uppercase badge-soft-warning me-2">{o.transaction_status}</span>;
                            break;
                        }

                        return <Fragment key={i}>
                          <tr className="product bg-light">
                            <td className="product-id">
                              <input
                                type="checkbox"
                                className={o.transaction_no && o.transaction_no !== "" ? "checkboxDetail ms-2 me-2 form-check-input" : "d-none"}
                                checked={o.isChecked}
                                onChange={() => {
                                  const updatedData = stockCard.map((d) => {
                                    return d.id === o.id ? { ...d, isChecked: !d.isChecked } : d;
                                  });

                                  setStockCard(updatedData);
                                }}
                              />
                            </td>
                            <td className="text-start fw-semibold">{o?.inv_product?.name}</td>
                            <td className="text-center">{handleValidDate(o.transactionat)}</td>
                            <td className="text-center">{o?.inv_transfer && o?.inv_transfer?.transaction_no} {o?.inv_purchase && o?.inv_purchase?.transaction_no}</td>
                            <td className="text-center fw-semibold">
                              {status}
                              {o?.inv_transfer && <span className={o?.inv_transfer?.type === "Production" ? "badge text-uppercase badge-soft-warning" : "badge text-uppercase badge-soft-primary"}> {o?.inv_transfer?.type}</span>}
                              {o?.inv_purchase && <span className="badge text-uppercase badge-soft-info"> Pembelian</span>}
                            </td>
                            <td className={"text-center fw-semibold"}>{o.inbound}</td>
                            <td className={"text-center fw-semibold"}>{o.outbond}</td>
                            <td className={"text-center fw-semibold"}>{o.saldo.toFixed(2)}</td>
                            <td className="text-start">{o.description}</td>
                          </tr>
                          {(o.inv_file || []).length > 0 && (
                            <tr>
                              <td></td>
                              <td colSpan={10} className="pe-0">
                                <Accordion className="p-0 w-100 border-0 lefticon-accordion accordion-primary custom-accordionwithicon">
                                  {(o.inv_file || []).length > 0 && (
                                    <AccordionItem className="border-0">
                                      <div
                                        className={classnames("accordion-button p-0 m-0 ps-4 fs-13", { collapsed: activeAccordion === i + 10000 ? false : true })}
                                        onClick={() => {
                                          toggleActiveAccordion(i + 10000);
                                        }}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <div className="p-2 text-info fw-semibold" style={{ width: "100%" }}>
                                          Bukti Transaksi
                                        </div>
                                      </div>
                                      <Collapse isOpen={activeAccordion === i + 10000 ? true : false} className="accordion-collapse bg-light border-0">
                                        <div className="accordion-body p-0 ps-4 pe-0 fw-normal fs-12 text-dark">
                                          {(o.inv_file || []).map((f, ii) => {
                                            let type;
                                            return (
                                              <div className="px-2 py-2 text-start border-bottom" key={ii}>
                                                {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                                  <ModalImage showRotate={true} small={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`} alt={f.originalname} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                                ) : (
                                                  <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                                    <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                                  </Link>
                                                )}
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </Collapse>
                                    </AccordionItem>
                                  )}
                                </Accordion>
                              </td>
                            </tr>
                          )}
                        </Fragment>


                      })}
                    {stockCard.length === 0 && (
                      <tr>
                        <td colSpan="11" className="p-3 text-center">
                          Belum ada data
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </SimpleBar>
            </CardBody>


          </ModalBody>
          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-warning"
                onClick={() => {
                  setModal(false);
                }}
              >
                Close
              </button>
            </div>
          </div>
        </Modal>

      </Container>
    </div >
  );
};
export default CivilBudget;
